import { TaskType } from 'api-validations/ag-concepts'
import type { CropSelection, PassDataFilters } from 'api-validations/tailor'
import { SpriteMap } from 'shared-ui/global'

/** One entry in the season selector: a year paired with either a crop or all of them. */
export type Season = {
  year: number
  crop: CropSelection
  cropLabel: string
}

export const TASK_KEYS = Object.values(TaskType)

export const initialFilters: PassDataFilters = Object.fromEntries(
  TASK_KEYS.map((k) => [k, true])
) as PassDataFilters

export const taskMeta = {
  [TaskType.Plant]: {
    color: {
      bar: 'border-task-plant',
      checkbox: 'bg-task-plant border-task-plant',
      text: 'text-task-plant'
    },
    icon: SpriteMap.PlanterIcon
  },
  [TaskType.Spray]: {
    color: {
      bar: 'border-task-spray',
      checkbox: 'bg-task-spray border-task-spray',
      text: 'text-task-spray'
    },
    icon: SpriteMap.SprayerIcon
  },
  [TaskType.Sidedress]: {
    color: {
      bar: 'border-task-sidedress',
      checkbox: 'bg-task-sidedress border-task-sidedress',
      text: 'text-task-sidedress'
    },
    icon: SpriteMap.SidedressIcon
  },
  [TaskType.Striptill]: {
    color: {
      bar: 'border-task-striptill',
      checkbox: 'bg-task-striptill border-task-striptill',
      text: 'text-task-striptill'
    },
    icon: SpriteMap.StripTillIcon
  },
  [TaskType.Harvest]: {
    color: {
      bar: 'border-task-harvest',
      checkbox: 'bg-task-harvest border-task-harvest',
      text: 'text-task-harvest'
    },
    icon: SpriteMap.CombineIcon
  }
} as const
